<div class="recruitment">
  <div class="content">
    <!-- Content -->
    <div class="content__wrapper" *ngIf="this.formSelected == this.STAGES">
      <app-config-stages-and-phases></app-config-stages-and-phases>
    </div>
    <div class="content__wrapper" *ngIf="this.formSelected == this.SCORE">
      <app-config-score
      ></app-config-score>
    </div>
  </div>
  <!-- Content -->
  <!-- Floating menu -->
  <div class="menu">
    <div
      class="menu__item"
      [class.menu__item--selected]="this.formSelected == this.STAGES"
      (click)="this.formSelected = this.STAGES"
    >
      <p>{{ this.STAGES }}</p>
    </div>
    <div
      class="menu__item"
      [class.menu__item--selected]="this.formSelected == this.SCORE"
      (click)="this.formSelected = this.SCORE"
    >
      <p>{{ this.SCORE }}</p>
    </div>
  </div>
  <!-- Floating menu -->
</div>
